import React, { PureComponent } from 'react';
import renderHTML from 'react-render-html';

import {
  StyledWrapper,
  StyledProgramsWrapper,
  StyledProgramsItem,
  StyledProgramHeader,
  StyledProgramNumber,
  StyledProgramDescription,
} from "./about.style";

import { StyledElementWrapperCenter, StyledElementHeaderTitle, StyledElementHeaderDescription } from 'styledElements';


// Texts
import text from 'i18l';

const STATIC_URL = '/program-myjni';

class About extends PureComponent {
  renderProgramsItems = () => text.ABOUT.PROGRAMS.map((programsItem, index) =>
    <StyledProgramsItem to={`${STATIC_URL}/${programsItem.slug}/${index}`} key={programsItem.key}>
      <StyledProgramHeader>
        {programsItem.name}
      </StyledProgramHeader>
      <StyledProgramNumber>
        {index}
      </StyledProgramNumber>
      <StyledProgramDescription className="program__description">
        {renderHTML(programsItem.description)}
      </StyledProgramDescription>
    </StyledProgramsItem>
  );

  render() {
    return (
      <StyledWrapper isSubpage={this.props.isSubpage || false}>
        <StyledElementWrapperCenter>
          <header>
            <StyledElementHeaderTitle>
              {text.ABOUT.TITLE}
            </StyledElementHeaderTitle>
            <StyledElementHeaderDescription>
              {text.ABOUT.DESCRIPTION}
            </StyledElementHeaderDescription>
          </header>
          <StyledProgramsWrapper>
            {this.renderProgramsItems()}
          </StyledProgramsWrapper>
        </StyledElementWrapperCenter>
      </StyledWrapper>
    );
  }
}

export default About;


// WEBPACK FOOTER //
// ./src/components/about/about.component.js